import { Component, HostBinding, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SkeletonComponent } from '@components/skeleton/skeleton.component';
import { SKELETON_CONSTANTS } from '@components/skeleton/skeleton.constants';

@Component({
  selector: 'app-profile-skeleton',
  templateUrl: './profile-skeleton.component.html',
  styleUrls: ['./profile-skeleton.component.scss'],
  standalone: true,
  imports: [CommonModule, SkeletonComponent]
})
export class ProfileSkeletonComponent {
  @Input() showHeader = true;
  @Input() showPosts = true;
  @Input() showSidebar = true;
  @Input() showAdSkeleton = true;
  @Input() showViewAllButtonSkeleton = true;

  readonly postIndices = [1, 2] as const;
  readonly sidebarCardIndices = new Array(
    SKELETON_CONSTANTS.RIGHT_SIDEBAR.STORE_CARD_COUNT
  );

  @HostBinding('class.main-content')
  get isFullLayout(): boolean {
    return this.showHeader || this.showSidebar;
  }
}
